import React from 'react';
import { useNavigate } from 'react-router-dom';
import { WidgetEmpty } from '../WidgetCard';
import {
  Globe, LifeBuoy, Newspaper, GraduationCap, Link2, ExternalLink,
} from 'lucide-react';

const ICONS = {
  globe: Globe, 'life-buoy': LifeBuoy, newspaper: Newspaper,
  'graduation-cap': GraduationCap, link: Link2,
};

export const CompanyLinksWidget = ({ data }) => {
  const navigate = useNavigate();
  const items = data?.items || [];

  if (!items.length) {
    return (
      <WidgetEmpty testId="company-links-empty">
        No company links have been set up yet. An administrator adds them under{' '}
        <button type="button" className="underline hover:no-underline"
          onClick={() => navigate('/announcements?tab=links')}
          data-testid="company-links-empty-manage">Announcements → Company links</button>.
      </WidgetEmpty>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-2" data-testid="company-links-list">
      {items.map((l) => {
        const Icon = ICONS[l.icon] || Link2;
        const internal = l.url.startsWith('/');
        const body = (
          <>
            <span className="w-8 h-8 rounded-md bg-surface-sunken flex items-center justify-center shrink-0">
              <Icon className="w-4 h-4 text-[hsl(var(--brand-accent))]" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-medium text-fg truncate">{l.label}</span>
              {l.description && (
                <span className="block text-xs text-fg-muted truncate">{l.description}</span>
              )}
            </span>
            {!internal && <ExternalLink className="w-3.5 h-3.5 text-fg-muted shrink-0" />}
          </>
        );
        const cls = `flex items-center gap-3 p-2.5 rounded-md border border-line bg-surface
          hover:bg-surface-sunken hover:border-[hsl(var(--brand-accent))]/40
          transition-colors duration-150 text-left w-full`;
        return internal ? (
          <button key={l.id} type="button" className={cls} onClick={() => navigate(l.url)}
            data-testid={`company-link-${l.id}`}>{body}</button>
        ) : (
          <a key={l.id} href={l.url} target="_blank" rel="noopener noreferrer" className={cls}
            data-testid={`company-link-${l.id}`}>{body}</a>
        );
      })}
    </div>
  );
};

export default CompanyLinksWidget;
